/* eslint-disable react-hooks/exhaustive-deps */
import { IconButton, InputAdornment, TextField } from "@mui/material"
import Grid from "@mui/material/Grid2";
import { useEffect } from "react";
import { useFormikContext } from "formik";
import { OnboardingFormValues } from "../Onboarding";
import get from "lodash/get";
import { HugeiconsIcon } from "@hugeicons/react";
import { Delete02Icon, Facebook01Icon, InstagramIcon, NewTwitterRectangleIcon, TiktokIcon } from "@hugeicons/core-free-icons";

const NETWORKS = [
    {
        id: 'instagram',
        icon: <HugeiconsIcon icon={InstagramIcon} />,
    },
    {
        id: 'facebook',
        icon: <HugeiconsIcon icon={Facebook01Icon} />,
    },
    {
        id: 'x',
        icon: <HugeiconsIcon icon={NewTwitterRectangleIcon} />,
    },
    {
        id: 'tiktok',
        icon: <HugeiconsIcon icon={TiktokIcon} />,
    },
]

const SocialNetworksStep = () => {
    const { values, setFieldValue } = useFormikContext<OnboardingFormValues>();

    const handleChange = (e: { target: { name: string; value: string; }; }) => {
        const value = e.target.value
            .toLowerCase()
            .replace(/\s+/g, "-")
            .replace(/[^a-z0-9-]/g, "");

        setFieldValue(e.target.name, value === '' ? undefined : value);
    }

    const handleDelete = (id: string) => {
        setFieldValue(id, undefined);
    }

    useEffect(() => {
        NETWORKS.forEach(({ id }) => {
            if (get(values, id, '') === '') {
                setFieldValue(id, values.alias);
            }
        })
    }, [])

    return (
        <Grid container>
            {NETWORKS.map(({ id, icon }) => (
                <Grid key={id} size={{ xs: 12, md: 6 }} p={1}>
                    <TextField
                        fullWidth
                        name={id}
                        value={get(values, id, '')}
                        onChange={handleChange}
                        slotProps={{
                            input: {
                                startAdornment: (
                                    <InputAdornment position="start">
                                        {icon}
                                    </InputAdornment>
                                ),
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton size="small" onClick={() => handleDelete(id)}>
                                            <HugeiconsIcon icon={Delete02Icon} />
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }
                        }}
                        sx={{
                            opacity: get(values, id, '') === '' ? 0.5 : 1
                        }}
                    />
                </Grid>
            ))}
        </Grid>
    )
}

export default SocialNetworksStep;
